import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Stack,
} from "@chakra-ui/react";
import MotionInView from "./MotionView";

const KiallitasVideo = () => {
  return (
    <Box py={{ base: 12, md: 16 }} bg="gray.50">
      <Container maxW="container.xl">
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          spacing={{ base: 10, lg: 14 }}
          alignItems="center"
        >
          {/* SZÖVEG */}
          <MotionInView x={-18} y={10}>
            <Stack spacing={5}>
              <Box>
                <Text
                  fontSize="sm"
                  fontWeight="800"
                  color="yellow.500"
                  textTransform="uppercase"
                  letterSpacing="0.08em"
                  mb={2}
                >
                  Kiállítás
                </Text>

                <Heading
                  fontSize={{ base: "2xl", md: "4xl" }}
                  fontWeight="900"
                  lineHeight="1.2"
                >
                  „Tájképek – Érzések”
                </Heading>

                <Box
                  w="90px"
                  h="4px"
                  bg="yellow.400"
                  rounded="full"
                  mt={4}
                />
              </Box>

              <Text color="gray.700" lineHeight="1.8">
                Hatalmas öröm és megtiszteltetés volt számunkra, hogy
                otthont adhattunk Harascsákné Somogyi Anna festőművész,
                egyben drága hozzátartozónk „Tájképek – Érzések” című
                kiállításának, amely először a Forrás Idősotthonban,
                majd a Bástya Idősotthonban is bemutatásra került.
              </Text>

              <Text color="gray.700" lineHeight="1.8">
                A megnyitókon nemcsak lenyűgöző képeket csodálhattunk meg,
                hanem egy gazdag életutat, a természethez való mély
                tiszteletet és a művészet gyógyító erejét is
                megismerhettük.
              </Text>

              <Box
                bg="white"
                borderLeft="4px solid"
                borderColor="yellow.400"
                p={{ base: 4, md: 5 }}
                rounded="lg"
                boxShadow="sm"
              >
                <Text color="gray.700" lineHeight="1.8">
                  Köszönjük a csodás pillanatokat, a megható gondolatokat
                  és mindazt az értéket, amit Anna néni a képein keresztül
                  nekünk ajándékozott!
                </Text>

                <Text mt={3} fontWeight="700">
                  Isten gazdag áldását kérjük életére, családjával együtt!
                </Text>
              </Box>
            </Stack>
          </MotionInView>

          {/* VIDEÓ */}
          <MotionInView x={18} y={10} delay={0.06}>
            <Box
              bg="white"
              p={{ base: 3, md: 4 }}
              rounded="2xl"
              boxShadow="md"
              borderWidth="1px"
              borderColor="gray.200"
            >
              <Box
                position="relative"
                w="100%"
                pt="56.25%"
                rounded="xl"
                overflow="hidden"
              >
                <Box
                  as="iframe"
                  position="absolute"
                  inset={0}
                  w="100%"
                  h="100%"
                  src="https://www.youtube.com/embed/kgQzIF5Ufo8"
                  title="Tájképek – Érzések kiállítás"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </Box>

              <Text
                mt={4}
                textAlign="center"
                fontSize="sm"
                color="gray.500"
              >
                Harascsákné Somogyi Anna „Tájképek – Érzések” című
                kiállításának pillanatai
              </Text>
            </Box>
          </MotionInView>
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default KiallitasVideo;